<app-promotion-detail-mobile
  *ngIf="isMobile$ | async"
  [promotionDetail]="promotionDetail"
></app-promotion-detail-mobile>
<app-promotion-detail-desktop
  *ngIf="!(isMobile$ | async)"
  [promotionDetail]="promotionDetail"
></app-promotion-detail-desktop>
